var _path, _path2, _linearGradient, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _circle, _circle2, _path6, _linearGradient4, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Water",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c15538",
    d: "M12.335.13a.497.497 0 0 0-.67 0C11.311.449 3 8.046 3 15c0 4.962 4.037 9 9 9s9-4.038 9-9C21 8.046 12.689.449 12.335.13z",
    className: "color303c42 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc9bb",
    d: "M12 23c-4.411 0-8-3.589-8-8 0-5.752 6.442-12.312 8-13.813 1.558 1.5 8 8.056 8 13.813 0 4.411-3.589 8-8 8z",
    className: "colorbbdefb svgShape"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 5.55,
    x2: 20.205,
    y1: 9.499,
    y2: 16.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.2,
    className: "stopColorffffff svgShape"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M12 23c-4.411 0-8-3.589-8-8 0-5.752 6.442-12.312 8-13.813 1.558 1.5 8 8.056 8 13.813 0 4.411-3.589 8-8 8z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 7.128,
    x2: 18.473,
    y1: 8.989,
    y2: 14.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.25,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M12.011 20.842c-3.237 0-5.871-3.234-5.871-7.208 0-5.183 4.728-11.093 5.871-12.446 1.143 1.352 5.871 7.259 5.871 12.446 0 3.974-2.634 7.208-5.871 7.208z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.892,
    x2: 10.892,
    y1: 19.484,
    y2: 4.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.31,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M10.892 19.484c-2.541 0-4.609-2.41-4.609-5.373 0-3.863 3.712-8.269 4.609-9.277.897 1.008 4.609 5.411 4.609 9.277 0 2.962-2.068 5.373-4.609 5.373z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.594,
    cy: 18.004,
    r: 0.802,
    fill: "#ffffff",
    opacity: 0.2,
    className: "colorffffff svgShape"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.709,
    cy: 16.307,
    r: 0.448,
    fill: "#ffffff",
    opacity: 0.2,
    className: "colorffffff svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c15538",
    d: "M12 20c-2.757 0-5-2.243-5-5a.5.5 0 0 0-1 0c0 3.309 2.691 6 6 6a.5.5 0 0 0 0-1z",
    className: "color303c42 svgShape"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 4.663,
    x2: 21.137,
    y1: 9.018,
    y2: 16.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.2,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M12.335.13a.497.497 0 0 0-.67 0C11.311.449 3 8.046 3 15c0 4.962 4.037 9 9 9s9-4.038 9-9C21 8.046 12.689.449 12.335.13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.40dd9ff4e3fdb3652a0040fb42881d9b.svg";
export { ForwardRef as ReactComponent };